import { Grid, Skeleton } from "@mui/material"
import Card from "components/Card"

import { homeContainer, customCardClasses } from "./style"

export default function PerformanceCardsLXO(props) {
  const { isLoading, cards, getCardValues } = props

  if (isLoading) {
    return (
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        columnSpacing={2}
        sx={homeContainer}
      >
        {Array.from(new Array(6)).map((_, index) => (
          <Grid key={index} item xs={12} sm={6} md={4} xxl={2.4}>
            <Skeleton
              variant="rectangular"
              height={88}
              sx={{ borderRadius: "16px" }}
            />
          </Grid>
        ))}
      </Grid>
    )
  }

  return (
    <Grid
      container
      sx={homeContainer}
      className="performance-cards performance-cards-lxo"
    >
      {cards.map((card, index) => {
        const data = getCardValues(index)
        // Bind per-card accentColor into the customCardClasses factory
        const cardClasses = (theme) =>
          customCardClasses(theme, card.accentColor)
        return (
          <Grid
            key={index}
            data-title={card.title}
            data-isPercent={card.isPercent}
          >
            <Card
              customCardClasses={cardClasses}
              {...card}
              progress={data.progress}
              diff={card.isPercent ? data.diff : 0}
            />
          </Grid>
        )
      })}
    </Grid>
  )
}
